/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Spec_LanguageInputs */

const en_fc_home_spec_language = /** @type {(inputs: Fc_Home_Spec_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Written in`)
};

/**
* | output |
* | --- |
* | "Written in" |
*
* @param {Fc_Home_Spec_LanguageInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_spec_language = /** @type {((inputs?: Fc_Home_Spec_LanguageInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Spec_LanguageInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_spec_language(inputs)
});
export { fc_home_spec_language as "fc.home.spec.language" }